import { render, staticRenderFns } from "./EmployeeDocuments.vue?vue&type=template&id=57411fb8&scoped=true&"
import script from "./EmployeeDocuments.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57411fb8",
  null
  
)

export default component.exports